import React, { useEffect, useState } from "react";
import _ from "lodash";
import cx from "classnames";
import { connect } from "react-redux";
import ReactSpinner from "react-spinjs-fix";
import { ButtonGroup } from "react-bootstrap";
import { makeStyles } from "@material-ui/styles";

import DocsItem from "./DocsItem";
import Back from "../../../widgets/Back";
import Show from "../../../widgets/Show";
import { Modal } from "../../../ui/Modal";
import FlexBox from "../../../ui/FlexBox";
import { SidebarPosition } from "../../../sidebar/Sidebar";
import uploadImage from "../../../../assets/images/upload-icon.png";
import addFolderImage from "../../../../assets/images/add-folder-icon.png";
import {
  getFolderList,
  patientDocsTabChangeHandler,
  updatePatientDocsItemName,
} from "../../../../actions/folderActions";

/*
 * getFolderList: () => void;
 * createFolder: () => void;
 * */
const useStyles = makeStyles(() => ({
  dialog: {
    top: 0,
    bottom: 0,
    margin: 0,
    width: "650px",
    display: "flex",
    position: "absolute",
  },
  content: {
    flex: 1,
    display: "flex",
    borderRadius: 0,
  },
  rightDialog: {
    right: "-650px",
    transition: "right 170ms ease-in-out",

    "&.open": {
      right: 0,
    },
  },
  leftDialog: {
    left: "-650px",
    transition: "left 170ms ease-in-out",

    "&.open": {
      left: 0,
    },
  },
  body: { padding: "0 !important", margin: 0, flex: 1, display: "flex", flexDirection: "column" },
}));

const enhancer = connect(null, null);
const DocsModal = (props) => {
  const classes = useStyles();
  const [files, setFiles] = useState([]);
  const [fileName, setFileName] = useState("");
  const [showEditNameModal, setShowEditNameModal] = useState(false);
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [renameFileValue, setRenameFileValue] = useState({});

  useEffect(() => {
    const { patientKey, folder } = props;

    props.dispatch(
      getFolderList({
        patientKey,
        folderId: _.last(folder.folderStack) || null,
      }),
    );
  }, []);

  const tabHandler = (tab) => {
    const { patientKey, folder } = props;
    const params = {
      patientKey,
      folderId: _.last(folder.folderStack) || null,
    };

    props.dispatch(patientDocsTabChangeHandler(tab, params));
  };

  const loadList = (event) => {
    const { patientKey, folder } = props;
    const scrollBottom =
      event.target.scrollTop + event.target.offsetHeight === event.target.scrollHeight;

    if (scrollBottom) {
      props.loadFilesList({
        patientKey,
        folderId: _.last(folder.folderStack) || null,
      });
    }
  };

  const onUpload = () => {
    // edit
    let today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();

    today = dd + "-" + mm + "-" + yyyy;
    const newFiles = [];
    [...files].forEach((originalFile) => {
      const fileExtension = originalFile.name.slice(
        (Math.max(0, originalFile.name.lastIndexOf(".")) || Infinity) + 1,
      );
      const newFile = new File(
        [originalFile],
        today === fileName ? originalFile.name : fileName + "." + fileExtension,
        {
          type: originalFile.type,
          lastModified: originalFile.lastModified,
        },
      );
      newFiles.push(newFile);
    });
    props.onUploadFiles(newFiles);
    setFiles([]);
    setFileName("");
    setShowEditNameModal(false);
  };

  const renameFiles = (files) => {
    let today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();

    today = dd + "-" + mm + "-" + yyyy;
    setShowEditNameModal(true);
    setFiles(files);
    setFileName(today);
  };

  const splitFileName = (filename) => {
    const mixtureMatch = filename.match(/\.(tar\.gz|tar\.bz2|min\.js)$/i);
    if (mixtureMatch) {
      const extension = mixtureMatch[1];
      const nameWithoutExt = filename.slice(0, mixtureMatch.index);
      return { name: nameWithoutExt, extension: extension };
    }

    const match = filename.match(/\.([^./]+)$/);
    if (match) {
      const extension = match[0];
      const nameWithoutExt = filename.slice(0, match.index);
      return { name: nameWithoutExt, extension: extension };
    } else {
      return { name: filename, extension: null };
    }
  };

  const renameSelectedItem = () => {
    const { folder } = props;
    const fileName = _.get(folder, "selectedFileToRename", "");
    const result = fileName?.type === "folder" ? fileName : splitFileName(fileName.name);

    setRenameFileValue(result);
    setShowRenameModal(true);
  };

  const onSaveRenamedFile = () => {
    const { patientKey } = props;
    props.dispatch(updatePatientDocsItemName(renameFileValue, patientKey));
    setRenameFileValue({});
    setShowRenameModal(false);
  };

  const {
    onRequestClose,
    onUploadImage,
    onCreateFolderClick,
    folder,
    open,
    position = SidebarPosition.Right,
  } = props;

  if (!open) {
    return null;
  }

  const currentFolder = _.last(folder.folderStack) || 0;
  const folderList = folder.folderList[currentFolder] || [];
  const filesList = folder.filesList[currentFolder] || [];

  let list = [];

  if (folder.isMoving) {
    list = folderList.filter((x) => !_.includes(folder.selectedFolders, x.id));
  } else {
    list = [...folderList, ...filesList];
  }

  const onHideModal = () => {
    setShowRenameModal(false);
    setRenameFileValue({ name: "", extension: null });
  };
  return (
    <>
      <Show if={showEditNameModal}>
        <Modal
          title="Edit file name"
          show={true}
          actions={
            <div>
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => {
                  setShowEditNameModal(false);
                  setFileName("");
                }}
              >
                cancel
              </button>
              <button type="button" className="btn btn-default" onClick={() => onUpload()}>
                ok
              </button>
            </div>
          }
        >
          <input
            className="form-control input-sm mb-3"
            type="text"
            value={fileName}
            onChange={({ target: { value } }) => setFileName(value)}
          />
        </Modal>
      </Show>
      <Modal
        show={true}
        animation={false}
        keyboard={false}
        onHide={onRequestClose}
        dialogClassName={cx("chart-side-bar", classes.dialog, {
          [classes.leftDialog]: position === SidebarPosition.Left,
          [classes.rightDialog]: position === SidebarPosition.Right,
          open,
        })}
      >
        <div className="chart-clinical-note">
          <div
            className="sidebar-header chart-side-header"
            style={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div className="w-100 d-flex align-items-center justify-content-between">
              <div
                style={{
                  flex: 1,
                  display: "flex",
                }}
              >
                {currentFolder > 0 ? (
                  <DocsItem
                    isBack={true}
                    item={{
                      type: "folder",
                    }}
                    openFolder={() =>
                      folder.isMoving
                        ? props.onSelectMoveFolder(
                            folder.folderStack.length >= 2
                              ? folder.folderStack[folder.folderStack.length - 2]
                              : null,
                            true,
                          )
                        : props.closeFolder()
                    }
                    folder={folder}
                  />
                ) : (
                  <Back onClick={props.onRequestClose} />
                )}
              </div>

              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                }}
              >
                <div
                  title="Upload"
                  onClick={onUploadImage}
                  className="clinic-note patient-note"
                  style={{
                    cursor: "pointer",
                    marginRight: "12px",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <img alt="" src={uploadImage} width={32} height={32} />
                  <input
                    style={{
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      opacity: 0,
                      width: "32px",
                      height: "32px",
                      cursor: "pointer",
                      position: "absolute",
                    }}
                    type="file"
                    tabIndex={-1}
                    multiple={true}
                    name="uploadFile"
                    onChange={({ target: { files } }) => renameFiles(files)}
                  />
                </div>
                <div
                  title="Add Folder"
                  onClick={onCreateFolderClick}
                  className="clinic-note patient-note"
                  style={{ cursor: "pointer", marginRight: "12px" }}
                >
                  <img alt="" src={addFolderImage} width={32} height={32} />
                </div>
              </div>
            </div>

            <Show if={folder.fetchingFolders}>
              <ReactSpinner />
            </Show>

            <div className="w-100" style={{ marginTop: "15px", padding: "0 5px" }}>
              <ButtonGroup aria-label="note tabs" className="d-flex align-items-center">
                <button
                  type="button"
                  onClick={() => tabHandler("activeDocs")}
                  className={`btn ${
                    folder.docsActiveTab !== "activeDocs" ? "btn-primary" : "btn-default"
                  } btn-block m-0`}
                >
                  Documents
                </button>
                <button
                  type="button"
                  onClick={() => tabHandler("archived")}
                  className={`btn ${
                    folder.docsActiveTab !== "archived" ? "btn-primary" : "btn-default"
                  } btn-block m-0`}
                >
                  Voided
                </button>
              </ButtonGroup>
            </div>
          </div>
          <div className="chart-side-body" onScroll={loadList}>
            {list.map((x, idx) => (
              <DocsItem
                item={x}
                key={idx}
                openFile={() => props.openFile(x.id)}
                isMoving={folder.isMoving}
                openFolder={() =>
                  folder.isMoving ? props.onSelectMoveFolder(x.id) : props.openFolder(x.id)
                }
                onSelect={() => props.selectItem(x.type, x.id)}
                selected={_.includes(
                  x?.type === "folder" ? folder.selectedFolders : folder.selectedFiles,
                  x.id,
                )}
                folder={folder}
              />
            ))}
          </div>
          <Show if={folder.docsActiveTab === "activeDocs"}>
            {Boolean(!_.isEmpty(folder.selectedFiles) || !_.isEmpty(folder.selectedFolders)) && (
              <FlexBox container={16}>
                <FlexBox flex={true} direction="row" gutter={8}>
                  <FlexBox flex={true}>
                    <button
                      onClick={props.onDelete}
                      style={{ width: "100%" }}
                      className="btn btn-success btn-lg"
                    >
                      Delete
                    </button>
                  </FlexBox>

                  <FlexBox flex={true}>
                    <button
                      onClick={props.onMove}
                      style={{ width: "100%" }}
                      className="btn btn-success btn-lg"
                    >
                      Move
                    </button>
                  </FlexBox>
                  <FlexBox flex={true}>
                    <button
                      onClick={renameSelectedItem}
                      style={{ width: "100%" }}
                      className="btn btn-success btn-lg"
                      disabled={[...folder.selectedFiles, ...folder.selectedFolders].length > 1}
                      title="Select only one item to rename !"
                    >
                      Rename
                    </button>
                  </FlexBox>
                </FlexBox>
              </FlexBox>
            )}
          </Show>
        </div>
      </Modal>
      <Show if={showRenameModal}>
        <Modal
          title="Edit file name"
          show={true}
          onHide={onHideModal}
          actions={
            <div>
              <button type="button" className="btn btn-danger" onClick={onHideModal}>
                cancel
              </button>
              <button type="button" className="btn btn-default" onClick={onSaveRenamedFile}>
                ok
              </button>
            </div>
          }
        >
          <input
            className="form-control input-sm mb-3"
            type="text"
            value={renameFileValue.name}
            onChange={({ target: { value } }) =>
              setRenameFileValue({ ...renameFileValue, name: value })
            }
          />
        </Modal>
      </Show>
    </>
  );
};
export default enhancer(DocsModal);
